export const VID_RSH_OPTIONS = [
  { value: 0, label: "Размещение" },
  { value: 1, label: "Питание" },
  { value: 2, label: "Лечение" }
];

export const IS_DAY_OPTIONS = [
  { value: 0, label: "Койкоместо" },
  { value: 1, label: "Сутки" }
];

export const IS_BABY_OPTIONS = [
  { value: 0, label: "Не учитывать" },
  { value: 1, label: "Да" },
  { value: -1, label: "Нет" }
];

/** VID PRIM → подпись вкладки и источник справочника. */
export const PRIM_TABS = [
  { vid: 1, label: "Категории номеров", shortLabel: "Категория", source: "number-cat" },
  { vid: 3, label: "Виды путевок", shortLabel: "Путёвка", source: "number-spr", sprVid: 1 },
  { vid: 2, label: "Виды питания", shortLabel: "Питание", source: "number-spr", sprVid: 5 },
  { vid: 4, label: "Виды мест", shortLabel: "Место", source: "number-spr", sprVid: 4, zeroLabel: "Основное" },
  { vid: 5, label: "Виды лечения", shortLabel: "Лечение", source: "number-spr", sprVid: 7, zeroLabel: "Без лечения" }
];

export const pick = (row, ...keys) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
  }
  return undefined;
};

export const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const normalizeZag = (row) => ({
  idNumberPrice: toNumber(pick(row, "idNumberPrice", "IdNumberPrice")),
  dateBeg: pick(row, "dateBeg", "DateBeg") ?? null,
  dateEnd: pick(row, "dateEnd", "DateEnd") ?? null,
  name: pick(row, "name", "Name") ?? ""
});

export const normalizeUsl = (row) => ({
  idNumberPrice: toNumber(pick(row, "idNumberPrice", "IdNumberPrice")),
  idStr: toNumber(pick(row, "idStr", "IdStr")),
  vidMesta: toNumber(pick(row, "vidMesta", "VidMesta")) ?? 0,
  name: pick(row, "name", "Name") ?? "",
  idUsl: toNumber(pick(row, "idUsl", "IdUsl")) ?? 0,
  uslName: pick(row, "uslName", "UslName") ?? "",
  srokMin: toNumber(pick(row, "srokMin", "SrokMin")) ?? 1,
  srokMax: toNumber(pick(row, "srokMax", "SrokMax")) ?? 999,
  cntClMin: toNumber(pick(row, "cntClMin", "CntClMin")) ?? 1,
  cntClMax: toNumber(pick(row, "cntClMax", "CntClMax")) ?? 999,
  vidPutevki: toNumber(pick(row, "vidPutevki", "VidPutevki")) ?? 0,
  zena: toNumber(pick(row, "zena", "Zena")) ?? 0,
  zenaHappy: toNumber(pick(row, "zenaHappy", "ZenaHappy")) ?? 0,
  isDay: toNumber(pick(row, "isDay", "IsDay")) ?? 0,
  isBaby: toNumber(pick(row, "isBaby", "IsBaby")) ?? 0,
  vidRsh: toNumber(pick(row, "vidRsh", "VidRsh")) ?? 0,
  idx: toNumber(pick(row, "idx", "Idx")) ?? 0
});

export const normalizePrim = (row) => ({
  idNumberPrice: toNumber(pick(row, "idNumberPrice", "IdNumberPrice")),
  idStr: toNumber(pick(row, "idStr", "IdStr")),
  vid: toNumber(pick(row, "vid", "Vid")),
  id: toNumber(pick(row, "id", "Id"))
});

/** Пустая применимость по справочнику = подходит любому значению (как подбор строки прайса). */
export const matchesPrimFilter = (idsForVid, filterId) => {
  if (filterId == null) return true;
  const ids = Array.isArray(idsForVid) ? idsForVid : [];
  if (ids.length === 0) return true;
  return ids.includes(filterId);
};

export const indexPrimByStr = (rows) => {
  const map = {};
  for (const row of (Array.isArray(rows) ? rows : []).map(normalizePrim)) {
    if (row.idStr == null || row.vid == null || row.id == null) continue;
    if (!map[row.idStr]) map[row.idStr] = {};
    if (!map[row.idStr][row.vid]) map[row.idStr][row.vid] = [];
    map[row.idStr][row.vid].push(row.id);
  }
  return map;
};

export const countPrim = (byVid) => {
  if (!byVid) return 0;
  return Object.values(byVid).reduce((n, ids) => n + (Array.isArray(ids) ? ids.length : 0), 0);
};

export const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

const startOfLocalDay = (value) => {
  const d = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
};

/** Прайс актуален, если сегодня попадает в [dateBeg, dateEnd]. */
export const isPriceCurrent = (zag, now = new Date()) => {
  const today = startOfLocalDay(now);
  if (!today) return true;
  const beg = zag?.dateBeg ? startOfLocalDay(zag.dateBeg) : null;
  const end = zag?.dateEnd ? startOfLocalDay(zag.dateEnd) : null;
  if (beg && today < beg) return false;
  if (end && today > end) return false;
  return true;
};

export const formatMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("ru-RU", { maximumFractionDigits: 2 });
};

export const formatRange = (min, max) => `${min ?? "—"}–${max ?? "—"}`;

export const labelByValue = (options, value) =>
  options.find((o) => o.value === value)?.label ?? (value == null ? "" : String(value));
